export default __webpack_public_path__ + "static/media/red-shift.3b117384.svg";